/* global http formValidation formHelper preloader*/
const form = {
	el: {
		html: document.documentElement,
		body: document.body,
		formElement: document.querySelector('.js-form'),
		inputElements: document.querySelectorAll('.form__input, .form__textarea')
	},

	fxFormEvents(selector) {

		const form = document.querySelector(selector)

		form.addEventListener('submit', e => {
			const el = e.currentTarget
			e.preventDefault()

			const callback = response => {
				preloader.fxPreloaderRemove(form)

				switch (response.status) {
					case 409:
						formHelper.fxShowMessage(form, form.dataset.msgConflict, 409)
						break
					case 500:
						formHelper.fxShowMessage(form, form.dataset.msgServer, 500)
						break

					default:
						formHelper.fxShowMessage(form, form.dataset.msgSuccess)
						break
				}
			}

			if (formValidation.fxValidate(el)) {
				preloader.fxPreloaderAdd(form)
				http.fxPost(el.getAttribute('action'), formHelper.fxFormToJson(el), callback)
			}

		})

		this.el.inputElements.forEach(el => el.addEventListener('focusout', () => this.fxInputsHasValue(el)))
	},

	fxInputsHasValue(el) {
		el.value.length ? el.classList.add('has-value') : el.classList.remove('has-value')
	},

	init() {
		if (!this.el.formElement) return
		this.fxFormEvents('.js-form')
		this.el.inputElements.forEach(el => this.fxInputsHasValue(el))
	}
}

form.init()
